// extracted by mini-css-extract-plugin
export default {"item":"pve1GwFP","selected":"yKzTlxDg"};